import { isJobProcessing, ExtendedPart } from "shared";

export const getIsAnalyzingAssembly = (part: ExtendedPart) => {
  return isJobProcessing(part.analyzeStatus);
};
